import React, { useState } from 'react';

export interface AdvanceQueryType {
  fileName: string;
  fileDesc: string;
  fileRevision: string;
  fileType: string;
  tags?: string[];
  allTagsPresent?: boolean;
}
export interface SearchQueryType {
  query: string;
  searchHandler: (query) => void;
  advancedQuery: AdvanceQueryType;
  advancedSearchHandler: (advancedQuery) => void;
}

const contextDefaultValues: SearchQueryType = {
  query: '',
  searchHandler: (query) => query,
  advancedQuery: {
    fileName: '',
    fileDesc: '',
    fileRevision: '',
    fileType: '',
    tags: [],
    allTagsPresent: true,
  },
  advancedSearchHandler: (advancedQuery) => advancedQuery,
};

export const SearchContext = React.createContext<SearchQueryType>(
  contextDefaultValues
);

// Defining a simple HOC component
const SearchContextProvider = (props) => {
  const [query, setQuery] = useState<string>('');
  const [advancedQuery, setAdvancedQuery] = useState({
    fileName: '',
    fileDesc: '',
    fileRevision: '',
    fileType: 'type-any',
    tags: [],
    allTagsPresent: true,
  });

  const searchHandler = (query) => {
    setQuery(query);
  };

  const advancedSearchHandler = (advancedQuery) => {
    setAdvancedQuery(advancedQuery);
  };

  return (
    <SearchContext.Provider
      value={{
        query,
        searchHandler,
        advancedQuery,
        advancedSearchHandler,
      }}>
      {props.children}
    </SearchContext.Provider>
  );
};

export default SearchContextProvider;
